import styled, { keyframes } from 'styled-components';
import { DisplayOrder } from '../DisplayOrder';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.5);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const Wrapper = styled.div`
  position: absolute;
  z-index: ${DisplayOrder.SlowActionLoader};
  width: 100%;
  height: 100%;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  /* 0.35s of delay seems to be enough
  for the loader not to appear on Android  */
  animation: ${fadeIn} 0.3s ease 0.35s both;
`;
